import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './WaitlistPopup.css';

function WaitlistPopup({ route, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    season: ''
  });
  const [phoneValue, setPhoneValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const seasons = [
    { value: 'fall-2025', label: 'Fall 2025 (Sep-Nov)' },
    { value: 'winter-2025', label: 'Winter 2025-26 (Dec-Feb)' },
    { value: 'spring-2026', label: 'Spring 2026 (Mar-May)' },
    { value: 'summer-2026', label: 'Summer 2026 (Jun-Aug)' },
    { value: 'not-sure', label: 'Not Sure Yet' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // Clear error when user types
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setError('Please enter your name');
      return false;
    }
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError('Please enter a valid email address');
      return false;
    }
    if (!phoneValue || phoneValue.length < 5) {
      setError('Please enter a valid phone number');
      return false;
    }
    if (!formData.season) {
      setError('Please select when you plan to travel');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://backpass-backend.onrender.com';
      const response = await fetch(`${backendUrl}/api/waitlist-signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          routeName: route.name,
          routeId: route.id,
          ...formData,
          phone: phoneValue
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to join waitlist');
      }

      setSuccess(true);

      // Auto close after 3 seconds
      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (err) {
      console.error('Waitlist signup error:', err);
      setError('Waitlist full, contact us to determine next steps.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="popup-overlay" onClick={onClose}>
        <div className="waitlist-popup-content success-content" onClick={(e) => e.stopPropagation()}>
          <div className="success-icon">✓</div>
          <h3>Waitlist Joined. :)</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="waitlist-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>×</button>

        <h3 className="waitlist-title">Reserve Your Spot</h3>
        <p className="waitlist-subtitle">{route.name} Pass</p>

        <form onSubmit={handleSubmit} className="waitlist-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter your full name"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="your@email.com"
              disabled={loading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <PhoneInput
              international
              defaultCountry="US"
              placeholder="Enter phone number"
              value={phoneValue}
              onChange={setPhoneValue}
              disabled={loading}
              className="phone-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="season">When do you plan to travel?</label>
            <select
              id="season"
              name="season"
              value={formData.season}
              onChange={handleInputChange}
              disabled={loading}
              required
            >
              <option value="">Select a season</option>
              {seasons.map(season => (
                <option key={season.value} value={season.value}>
                  {season.label}
                </option>
              ))}
            </select>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="waitlist-submit-button"
            disabled={loading}
          >
            {loading ? 'Joining...' : 'Send'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default WaitlistPopup;